var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionsButtonLargeIcon = function SvgActionsButtonLargeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M31.34 16.278a124 124 0 0 0-5.667 4.974c-.603.567-1.159 1.157-1.773 1.724-.383-.393-.754-.798-1.16-1.157-2.55-2.568-4.983-4.778-6.13-5.715a.337.337 0 0 0-.487 0 .347.347 0 0 0 0 .486c.985.925 2.874 3.1 5.088 5.484l1.704 1.828c-.626.66-1.206 1.295-1.785 1.92-2.121 2.314-3.895 4.35-5.03 5.588a.347.347 0 0 0 .243.59.34.34 0 0 0 .243-.104 576 576 0 0 0 6.201-5.947c.36-.347.73-.729 1.09-1.087l.834.844a200 200 0 0 0 5.969 5.854.395.395 0 0 0 .556-.555c-1.066-1.157-2.92-3.274-5.03-5.565l-1.402-1.515 1.6-1.678c1.877-1.909 3.731-3.83 5.458-5.414a.398.398 0 1 0-.521-.602z",
    clipRule: "evenodd"
  })));
};
export default SvgActionsButtonLargeIcon;